import Immutable from 'immutable';

import StudentGeneralInfo from 'domain/StudentGeneralInfo';
import Interval from 'domain/Interval';
import { ACH } from './model';
import Member from './';

const reviver = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {
    case 'studentGeneralInfo':
      return [key, StudentGeneralInfo.create(item)];
    case 'period':
      return [key, Interval.create({
        start: item.start,
        end: item.end,
      })];
    case 'ach':
      return [key, new ACH(item)];
    default:
      return [key, Immutable.fromJS(item)];
  }
};

export const create = (data) =>
  new Member(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/GroupMembers/model/create.js